export const API_ERROR = "api_failed";

export const SR_RFQ_LIST = "SR_rfq_list";
export const SR_RFQ_LIST_SUCCESS = "SR_rfq_list_success";
export const SR_Q_VENDORS_LIST = "SR_q_vendors_list";
export const SR_Q_VENDORS_LIST_SUCCESS = "sR_q_vendors_success";

export const INPUT_SR_CHANGEVALUE = "Q_input_SR_ChangeValue";
export const RFQ_NO_SELECT_SR_CHANGEVALUE = "Q_rfq_Select_SR_ChangeValue";
export const SELECT_SR_CHANGEVALUE = "Q_Select_SR_ChangeValue";

export const SR_RFQ_ROW_DATA = "Q_SR_rfq_row_data";
export const SR_RFQ_ROW_DATA_SUCCESS = "Q_SR_rfq_row_data_success";
export const SR_QSR_ITEM_REMOVE = "SR_Qitem_remove";

export const SR_ITEM_QTY_SR_CHANGEVALUE = "item_qty_SR_ChangeValue";
export const SR_ITEM_UNIT_SR_CHANGEVALUE = "item_unit_SR_ChangeValue";
export const SR_ITEM_PRICE_SR_CHANGEVALUE = "item_price_SR_ChangeValue";
export const SR_ITEM_BASEPRICE_SR_CHANGEVALUE = "item_baseprice_SR_ChangeValue";
export const SR_ITEM_DISC_PERCENT_SR_CHANGEVALUE = "item_desc_percent_SR_ChangeValue";
export const SR_ITEM_TAX_SR_CHANGEVALUE = "item_tax_SR_ChangeValue";
export const SR_ITEM_TAXTYPE_SR_CHANGEVALUE = "item_taxtype_SR_ChangeValue";
export const SR_ITEM_GROSS_VAL_SR_CHANGEVALUE = "item_grossVal_SR_ChangeValue";

export const SR_QUOTATION_ADD = "SR_qoutation_add";
export const SR_QUOTATION_LIST = "SR_qoutation_list";
export const SR_QUOTATION_LIST_SUCCESS = "SR_qoutation_list_success";
export const TOGGLE_SR_ITEM_MENU = "q_toggle_item_menu";

export const SET_PARAMS = "Q_set_params";
export const FILTER_INPUT_SR_CHANGEVALUE = "pi_Filter_input_SR_ChangeValue";
export const FILTER_SELECT_SR_CHANGEVALUE = "pi_Filter_Select_SR_ChangeValue";

export const Q_SR_MODEL_LIST_OPEN = "q_listItem_model_open";
export const Q_SR_MODEL_LIST_CLOSE = "q_listItem_model_close";

export const SR_QOUTATION_DATA = "SR_qoutation_data";
export const SR_QOUTATION_DATA_SUCCESS = "SR_qoutation_data_success";
export const SR_LIST_LAYOUT = "Q_list_layout";

export const SRQ_FILTERS_SHOW_RIGHT_SIDEBAR = "SRQ_filter_show_right_sidebar";
export const SR_FILTERS_HIDE_RIGHT_SIDEBAR = "Q_filter_hide_right_sidebar";
export const CLEAR_FILTER = "Q_clear_filter";

export const RFQ_SR_FILTERS_LIST = "Q_rfq_filter_list";
export const RFQ_SR_FILTERS_LIST_SUCCESS = "Q_rfq_filter_list_success";

export const SR_MR_CODE_DETAILS = "SR_Q_sr_code_details";
export const SR_MR_CODE_DETAILS_SUCCESS = "SR_Q_sr_code_details_Successful";

export const SR_PI_CODE_DETAILS = "SR_Q_pi_code_details";  
export const SR_PI_CODE_DETAILS_SUCCESS = "SR_Q_pi_code_details_Successful";

export const MR_SR_ITEM_IMAGES = "SR_Q_sr_item_images";
export const MR_SR_ITEM_IMAGES_SUCCESS = "SR_Q_sr_item_images_Successful";
export const RFQ_MR_SR_ITEM_IMAGES_SR_MODEL_CLOSE = "SR_Q_sr_item_images_model_close";
